import styled  from 'styled-components';
import Buttons from '@klv/molecules/buttons';
import Grid from '@klv/utils/grid';
import Typography from '@klv/atoms/typography';

import FadeInUp from '../../../atoms/fade-in-up';

export  const StyledFinalCta = styled(FadeInUp)`
  padding: 5.6rem 0 4.8rem 0;
  width: 100%;
  
  ${({ theme }) => `
    ${theme.screenSize.s380.mediaQuery} {
    }
    ${theme.screenSize.s576.mediaQuery} {
      padding: 9.8rem 0 9rem 0;
    }
    ${theme.screenSize.s768.mediaQuery} {
      padding: 9.8rem 0 9.8rem 0;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      padding: 11.2rem 0 9rem 0;
    }
  `}
`;

export const FinalCtaGrid = styled(Grid)``;

export const StyledHeadline = styled(Typography)`
  ${({ theme }) => `
    ${theme.fonts.sohne.light}
    grid-column: 1/-1;
    text-align: center;
    font-size: 2.4rem;
    line-height: 1.4;
    margin-bottom: 2rem;
    color: ${theme.colors.white};

    ${theme.screenSize.s576.mediaQuery} {
      font-size: 3.2rem;
    }
    ${theme.screenSize.s768.mediaQuery} {
      font-size: 3.6rem;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      font-size: 4rem;
      line-height: 1.5;
      grid-column: 3/11;
    }
    ${theme.screenSize.s1200.mediaQuery} {
      font-size: 4.8rem;
      line-height: 1.3;
    }
  `}
`;

export const StyledSubhead = styled.p`
  grid-column: 1/-1;
  text-align: center;
  font-family: "Sohne";
  font-size: 1.6rem;
  line-height: 1.44;
  margin-bottom: 6.4rem;

${({ theme }) => `
    color: ${theme.colors.white};

    ${theme.screenSize.s576.mediaQuery} {
      margin-bottom: 3.2rem;
    }
    ${theme.screenSize.s768.mediaQuery} {
      margin-bottom: 6.4rem;
      grid-column: 3/11;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      font-size: 1.8rem; 
    }
    ${theme.screenSize.s1200.mediaQuery} {
      font-size: 2rem; 
    }
  `}
`;

export const StyledButtons = styled(Buttons)`
  grid-column: 1/-1;
  margin: 0 auto;

  ${({ theme }) => `
    ${theme.screenSize.s768.mediaQuery} {
      grid-column: 5/9;
    }
  `}
`;

export default StyledFinalCta;
